import { useLayoutEffect, useState } from "react";
import InspoGrid from "./Grid";
import clsx from "clsx";
import CallToAction from "./CallToAction";
import CategoryFilters from "./CategoryFilters";
import { getSessionStorage } from "@/helpers/handleSessionStorage";

function getQueryParam(name: string, url?: string) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const InspirationComponent = ({ onSearchSubmit = () => {} }: { onSearchSubmit?: (query: boolean) => void }) => {
  const [selected, setSelected] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [searchParams] = useState(window.location.href);

  useLayoutEffect(() => {
    const isExpanded = getQueryParam("expanded");

    if (isExpanded) {
      const filter = getSessionStorage("syfIncFilter");

      filter && setSelected(filter);
    }

    if (selected.length) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [searchParams, selected]);

  return (
    <div className={clsx(expanded ? "pb-[20px] h-full" : "min-w-[375px] md:h-[526px] lg:h-[530px] xl:h-[386px]", "w-full bg-[#f6f6f6] flex flex-col")}>
      <div className="max-w-[1440px] mx-auto">
        <div className={clsx(expanded ? "-mt-1 md:-mt-2" : "mt-16 md:mt-48 md:-top-80", " md:relative z-10 mx-[16px] sm:mx-[56px] ")}>
          {!expanded ? (
            <div className="flex items-center text-charcoal md:text-white">
              <img src={searchPromptDetails?.searchIcon} alt="" className="h-[16px] w-[16px] mr-[8px] mb-[26px] sm:w-[16px] md:invert lg:invert h-[20px] xl:invert" />

              <h2 id="examples" className="mb-[24px] font-bold text-[16px] sm:text-[20px] leading-[24px] uppercase">
                {searchPromptDetails.promptSectionHeading}
              </h2>
            </div>
          ) : null}

          <div className={clsx(expanded ? "flex-col-reverse" : "flex-col", "flex")}>
            <InspoGrid expanded={expanded} selected={selected} onSearchSubmit={onSearchSubmit} />
            <CategoryFilters selected={selected} setSelected={setSelected} />
          </div>

          <div className="w-full flex flex-col">{expanded ? <CallToAction /> : null}</div>
        </div>
      </div>
    </div>
  );
};

export default InspirationComponent;
